import { mapMutations, mapGetters, mapActions } from "vuex";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
    name: "add-main-address-form",
    props: ["form"],
    mixin: [validationMixin],
    data() {
        return {
            payload: {
                active: 0,
                city: "",
                street: "",
                house: "",
                flat: "",
            },
            isEdit: true,
            showLoader: false,
            validationErrors: {},
        };
    },
    validations() {
        return {
            payload: {
                city: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(30),
                },
                street: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(50),
                },
                house: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                flat: {
                    required,
                    minLength: minLength(1),
                    maxLength: maxLength(8),
                },
                active: {},
            },
        };
    },
    created() {},
    mounted() {
        if (this.form) {
            this.payload.active = this.form.active;
            this.payload.city = this.form.city;
            this.payload.street = this.form.street;
            this.payload.house = this.form.house;
            this.payload.flat = this.form.flat;
        }
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
            addAddressLoading: "profile/addAddressLoading",
            removeAddressLoading: "profile/removeAddressLoading",
            editAddressLoading: "profile/editAddressLoading",
        }),
        cityErrors() {
            let error = [];
            if (!this.$v.payload.city.$dirty) {
                return error;
            }
            if (!this.$v.payload.city.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.city.maxLength) {
                error.push(this.$t("validationMax") + " 30");
            }
            if (!this.$v.payload.city.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.city) {
                this.validationErrors.city.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        streetErrors() {
            let error = [];
            if (!this.$v.payload.street.$dirty) {
                return error;
            }
            if (!this.$v.payload.street.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.street.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.street.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.street) {
                this.validationErrors.street.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        houseErrors() {
            let error = [];
            if (!this.$v.payload.house.$dirty) {
                return error;
            }
            if (!this.$v.payload.house.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.house.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (!this.$v.payload.house.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.house) {
                this.validationErrors.house.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        flatErrors() {
            let error = [];
            if (!this.$v.payload.flat.$dirty) {
                return error;
            }
            if (!this.$v.payload.flat.minLength) {
                error.push(this.$t("validationMin") + " 1");
            }
            if (!this.$v.payload.flat.maxLength) {
                error.push(this.$t("validationMax") + " 8");
            }
            if (!this.$v.payload.flat.required) {
                error.push(this.$t("validationRequired"));
            }
            if (this.validationErrors.flat) {
                this.validationErrors.flat.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (
                this.payload.city === this.form.city &&
                this.payload.street === this.form.street &&
                this.payload.house === this.form.house &&
                this.payload.flat === this.form.flat &&
                this.payload.active === this.form.active
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        ...mapActions({
            addUserAddress: `profile/ADD_USER_ADDRESS`,
            editUserAddress: `profile/EDIT_USER_ADDRESS`,
            deleteUserAddress: `profile/REMOVE_USER_ADDRESS`,
            fetchUserData: `profile/FETCH_USER_DATA`,
        }),
        ...mapMutations({}),
        cancel() {
            this.payload.city = "";
            this.payload.street = "";
            this.payload.house = "";
            this.payload.flat = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        changeEdit() {
            this.isEdit = false;
        },
        editCancel() {
            this.isEdit = true;
            this.payload.active = this.form.active;
            this.payload.city = this.form.city;
            this.payload.street = this.form.street;
            this.payload.house = this.form.house;
            this.payload.flat = this.form.flat;
            this.$nextTick(() => {
                this.$v.$reset();
            });
        },
        removeAddress() {
            let obj = {};
            obj.id = this.form.id;
            this.showLoader = true;
            this.deleteUserAddress(obj)
                .then(() => {
                    this.$toasted.success(this.$t("youAddressRemove"));
                    this.fetchUserData();
                    this.showLoader = false;
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.showLoader = false;
                    }
                });
        },
        submit() {
            this.$v.$touch();
            let obj = {};
            obj.city = this.payload.city;
            obj.active = this.payload.active;
            obj.street = this.payload.street;
            obj.house = this.payload.house;
            obj.flat = this.payload.flat;
            obj.id = this.form.id;
            this.showLoader = true;
            if (!this.$v.$invalid) {
                this.editUserAddress(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("youAddressRefresh"));
                        this.fetchUserData();
                        this.showLoader = false;
                        this.isEdit = true;
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showLoader = false;
                            this.isEdit = true;
                        }
                    });
            }
        },
    },
};
